import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { SubscriptionModel } from '../../../../../models/aggregates/subscription';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionHdrService extends BaseApiTemplateService<SubscriptionModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/sysadmin-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/sysadmin-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/sysadmin-ep';
    this.httpClient = http;
  }
}

